export const setMyLocalStorageProjects = (val) => {
	localStorage.setItem('rememberMyProjects', val);
};
export const setMyLocalStorageProjectsKw = (val) => {
	localStorage.setItem('rememberMyProjectsKw', val);
};
export const getMyLocalStorageProjects = () => {
	return localStorage.getItem('rememberMyProjects');
};
export const getMyLocalStorageProjectsKw = () => {
	return localStorage.getItem('rememberMyProjectsKw');
};

export const setMyLocalStorageProjectsComplaints = (val) => {
	localStorage.setItem('rememberComplaints', val);
};

export const getMyLocalStorageProjectsComplaints = () => {
	return localStorage.getItem('rememberComplaints');
};

// Project Sort Persistence
export const setProjectSortPreferences = (sort, sortBy) => {
  localStorage.setItem('projectSortDirection', sort);
  localStorage.setItem('projectSortBy', sortBy);
};

export const getProjectSortDirection = () => {
  return localStorage.getItem('projectSortDirection') || '-';
};

export const getProjectSortBy = () => {
  return localStorage.getItem('projectSortBy') || 'id';
};

export const clearProjectSortPreferences = () => {
  localStorage.removeItem('projectSortDirection');
  localStorage.removeItem('projectSortBy');
};

// Session storage functions for project list navigation
export const setLastViewedProjectId = (projectId) => {
	sessionStorage.setItem('lastViewedProjectId', projectId);
};

export const getLastViewedProjectId = () => {
	return sessionStorage.getItem('lastViewedProjectId');
};

export const clearLastViewedProjectId = () => {
	sessionStorage.removeItem('lastViewedProjectId');
};
